import type {ReactElement} from "react";
import {Chip, type ChipProps} from "@mui/material";
import ScheduleIcon from '~/icons/svg/ScheduleIcon.svg?react'
import WarningCircleIcon from '~/icons/svg/WarningCircleIcon.svg?react'
import InfoIcon from '~/icons/svg/InfoIcon.svg?react'
import type {ComplianceReminderState} from "~/pages/supplier-360/types/Supplier360Types";

const ICON_SIZE = {width: 14, height: 14};

/**
 * `REMINDER_CHIP[last_reminder_state]` — the stored reminder state (§2.8) as a chip, with the
 * design's copy (§4.8) and icons (`sxcReminder`).
 */
export const REMINDER_CHIP: Record<ComplianceReminderState, ReactElement<ChipProps>> = {
    scheduled: <Chip size="small" color="info" label="Scheduled · 30d reminder" icon={<InfoIcon {...ICON_SIZE}/>}/>,
    reminder_sent: <Chip size="small" color="warning" label="Reminder sent to supplier" icon={<ScheduleIcon {...ICON_SIZE}/>}/>,
    final_reminder_sent: <Chip size="small" color="error" label="Final reminder sent" icon={<ScheduleIcon {...ICON_SIZE}/>}/>,
    escalated: <Chip size="small" color="error" label="Escalated internally" icon={<WarningCircleIcon {...ICON_SIZE}/>}/>,
    no_expiry: <Chip size="small" label="No expiry date" icon={<InfoIcon {...ICON_SIZE}/>}/>,
};
